import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { selectResponsiveTarget } from '@immosky/object-search-layout';
import { select, Store } from '@ngrx/store';
import { AppState, ResponsiveTarget } from '@immosky/types';
import { LayoutService } from '../../services/layout.service';

@Component({
  selector: 'app-sticky-buttons',
  templateUrl: './sticky-buttons.component.html',
  styleUrls: ['./sticky-buttons.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StickyButtonsComponent implements AfterViewInit {
  isFixed = false;
  containerHeight = 'auto';
  currentScrollPosition = 0;
  lastScrollPosition = -1;
  lastScrollDirection: 'unknown' | 'up' | 'down' = 'unknown';

  halfVisible = false;
  canAnimate = false;

  responsiveTarget: ResponsiveTarget = ResponsiveTarget.XS;

  // header from django
  siteHeader!: HTMLElement | null;

  @ViewChild('container')
  containerRef!: ElementRef<HTMLElement>;

  constructor(
    private cdRef: ChangeDetectorRef,
    private store: Store<AppState>,
    private layoutService: LayoutService
  ) {
    this.store
      .pipe(select(selectResponsiveTarget))
      .subscribe((responsiveTarget: ResponsiveTarget) => {
        this.responsiveTarget = responsiveTarget;
      });
  }

  ngAfterViewInit(): void {
    this.siteHeader = document.querySelector<HTMLElement>('.header');

    window.addEventListener('scroll', () => {
      this.update();
    });
    this.update();
  }

  private update() {
    this.updateCurrentScrollPosition();
    this.updateScrollDirection();
    this.updateIsFixed();
    this.updateSiteHeader();
    this.updateLastScrollPosition();
    this.cdRef.detectChanges();
  }

  private updateIsFixed() {
    const container = this.containerRef.nativeElement;
    const containerHeight = container.clientHeight;
    const containerRect =
      this.containerRef.nativeElement.getBoundingClientRect();

    if (containerRect.top <= this.getThreshold()) {
      this.isFixed = true;
      this.containerHeight = `${containerHeight}px`;
      this.halfVisible = this.lastScrollDirection === 'down';
    } else {
      this.isFixed = false;
      this.halfVisible = false;
      this.containerHeight = 'auto';
    }

    window.requestAnimationFrame(() => {
      this.canAnimate = containerRect.top <= -50;
    });
  }

  private getThreshold(): number {
    let threshold = -50;
    if (
      (this.isFixed && !this.halfVisible) ||
      this.responsiveTarget > ResponsiveTarget.XS
    ) {
      threshold = 0;
    }

    return threshold;
  }

  private updateSiteHeader() {
    if (this.siteHeader) {
      if (this.isFixed && this.responsiveTarget < ResponsiveTarget.MD) {
        this.siteHeader.style.display = 'none';
      } else {
        this.siteHeader.style.display = '';
      }
    }
  }

  private updateCurrentScrollPosition() {
    this.currentScrollPosition = window.scrollY;
  }

  private updateScrollDirection() {
    if (this.currentScrollPosition > this.lastScrollPosition) {
      this.lastScrollDirection = 'down';
    } else {
      this.lastScrollDirection = 'up';
    }
  }

  private updateLastScrollPosition() {
    this.lastScrollPosition = this.currentScrollPosition;
  }

  openMobileFilter() {
    this.layoutService.openMobileFilters();
  }
}
